import { createMatchSelector } from 'connected-react-router';
import { path, pipe } from 'ramda';

import Patient from 'components/ResearcherPatientPage';
import withPageLoader from 'components/withPageLoader';

import { requestPatientsData } from 'store/actionCreators/patientsData';
import { getPatientShouldShowLoading } from 'store/selectors/patientsData';

export default withPageLoader({
  loadingSelector: (state, ownProps) => {
    const patientId = path(['match', 'params', 'id'], ownProps);
    return getPatientShouldShowLoading(patientId)(state);
  },
  initialActionArgsSelector: state => {
    const patientId = pipe(
      createMatchSelector('/patient/:id'),
      path(['params', 'id']),
    )(state);
    return { id: patientId };
  },
  initialAction: requestPatientsData,
})(Patient);
